/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type DeleteGooseGamePrizeMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type DeleteGooseGamePrizeMutation = {
  deleteGooseGameStoreItem: Pick<Types.GooseGameItem, "id" | "name">;
};

export const DeleteGooseGamePrizeDocument = gql`
  mutation DeleteGooseGamePrize($id: Float!) {
    deleteGooseGameStoreItem(id: $id) {
      id
      name
    }
  }
`;

/**
 * __useDeleteGooseGamePrizeMutation__
 *
 * To run a mutation, you first call `useDeleteGooseGamePrizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGooseGamePrizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGooseGamePrizeMutation, { data, loading, error }] = useDeleteGooseGamePrizeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGooseGamePrizeMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteGooseGamePrizeMutation,
    DeleteGooseGamePrizeMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteGooseGamePrizeMutation,
    DeleteGooseGamePrizeMutationVariables
  >(DeleteGooseGamePrizeDocument, baseOptions);
}
export type DeleteGooseGamePrizeMutationHookResult = ReturnType<
  typeof useDeleteGooseGamePrizeMutation
>;
export type DeleteGooseGamePrizeMutationResult =
  ApolloReactCommon.MutationResult<DeleteGooseGamePrizeMutation>;
export type DeleteGooseGamePrizeMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteGooseGamePrizeMutation,
    DeleteGooseGamePrizeMutationVariables
  >;
